import { css } from '@emotion/react'

import { colors } from '../../../../styles/theme'

export default css`
  background: ${colors.white};

  .cr-logo-svg {
    fill: ${colors.orange};

    @media (hover: hover) {
      &:hover {
        fill: ${colors.orange};
      }
    }
  }

  .to-top {
    color: ${colors.scarpaFlow};

    .icon-chevron {
      stroke: ${colors.scarpaFlow};
    }

    @media (hover: hover) {
      &:hover {
        color: ${colors.silverChalice};

        .icon-chevron {
          stroke: ${colors.silverChalice};
        }
      }
    }
  }

  .social-link {
    background-color: ${colors.scarpaFlow};

    .social-icon {
      fill: ${colors.white};

      .vk {
        &-bg {
          fill: ${colors.black};
        }

        &-logo {
          fill: ${colors.white};
        }
      }
    }

    @media (hover: hover) {
      &:hover {
        background-color: ${colors.silverChalice};

        .vk-bg {
          fill: ${colors.silverChalice};
        }
      }
    }
  }

  .legal-item > span {
    color: ${colors.scarpaFlow};
  }

  .legal-link,
  .legal-dns span {
    color: ${colors.scarpaFlow};

    @media (hover: hover) {
      &:hover {
        color: ${colors.silverChalice};
      }
    }
  }

  .language {
    &-toggle {
      color: ${colors.scarpaFlow};
      background-color: ${colors.alabaster};
    }

    &-current {
      .triangle-svg {
        fill: ${colors.scarpaFlow};
      }

      @media (hover: hover) {
        &:hover {
          color: ${colors.silverChalice};

          .triangle-svg {
            fill: ${colors.silverChalice};
          }
        }
      }
    }

    &-list {
      background-color: ${colors.alabaster};
      border-bottom: 0.0625rem solid ${colors.scarpaFlow};
    }

    &-item {
      @media (hover: hover) {
        &:hover {
          color: ${colors.silverChalice};
        }
      }
    }
  }

  .byline {
    color: ${colors.silverChalice};
  }
`
